import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const MaterialMaintenanceService = {
    list: async () => axios.post(`${API_URL}/material-maintenances/list`).then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/material-maintenances/${id}`).then(({data}) => data).catch((err) => { throw err }),
    save: async (formData, id) => {
        if (id) {
            formData.append('_method', 'PUT');
            return axios.post(`${API_URL}/material-maintenances/${id}`, formData).then(({data}) => data).catch((err) => { throw err })
        }

        return axios.post(`${API_URL}/material-maintenances`, formData).then(({data}) => data).catch((err) => { throw err })
    },
}

export default MaterialMaintenanceService;